import { render, staticRenderFns } from "./open-bill.vue?vue&type=template&id=9649108e&scoped=true&"
import script from "./open-bill.vue?vue&type=script&lang=js&"
export * from "./open-bill.vue?vue&type=script&lang=js&"
import style0 from "./open-bill.vue?vue&type=style&index=0&id=9649108e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9649108e",
  null
  
)

export default component.exports